import React, { useState } from 'react';
import { toast } from 'sonner';
import { apiDownloadBlob } from '../../../api/client';
import { Button } from '../../../components/ui/Button';
import { Section } from '../../../components/ui/Section';
import { Database } from 'lucide-react';

export default function BackupSection() {
  const [downloadingDump, setDownloadingDump] = useState(false);
  const [downloadingJson, setDownloadingJson] = useState(false);

  const handleDumpDownload = async () => {
    setDownloadingDump(true);
    try {
      await apiDownloadBlob('/admin/backup/database', `lenscrm-backup-${new Date().toISOString().slice(0, 10)}.dump`);
      toast.success('Dump database scaricato');
    } catch (e: unknown) {
      toast.error((e as Error).message ?? 'Errore durante il dump');
    } finally {
      setDownloadingDump(false);
    }
  };

  const handleJsonDownload = async () => {
    setDownloadingJson(true);
    try {
      await apiDownloadBlob('/admin/backup/full-json', `lenscrm-backup-${new Date().toISOString().slice(0, 10)}.json`);
      toast.success('Backup JSON scaricato');
    } catch (e: unknown) {
      toast.error((e as Error).message ?? 'Errore durante il backup JSON');
    } finally {
      setDownloadingJson(false);
    }
  };

  return (
    <Section title="Backup dati">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
          Scarica un dump completo del database (formato PostgreSQL) o un export JSON di tutte le entità.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <Button onClick={handleDumpDownload} loading={downloadingDump} icon={<Database size={14} />}>
            Scarica Dump Database (.dump)
          </Button>
          <Button onClick={handleJsonDownload} loading={downloadingJson}>
            Scarica Backup JSON (.json)
          </Button>
        </div>
      </div>
    </Section>
  );
}
